export default class GrilleErrorsComponentController {
    static $inject = ['TarifsService', '$timeout'];

    TarifsService: any;
    $timeout: any;
    loading: boolean = true;
    showSuccess: boolean = false;
    hasErrorGrille: boolean = false;
    hasErrorGrilleGranulats: boolean = false;
    hasErrorGrilleEnrobes: boolean = false;
    hasErrorGrilleLiants: boolean = false;
    hasErrorGrillePrestations: boolean = false;
    hasErrorGrilleTransports: boolean = false;

    id: number;
    refreshKey: any;
    section: string;
    mode: string;
    hasError: boolean | undefined;
    isLoading: boolean;

    constructor(TarifsService: any, $timeout: any) {
        this.TarifsService = TarifsService;
        this.$timeout = $timeout;
    }

    async $onInit() {
        if (!this.hasExternalData) await this.load();
        else this.loading = false;
    }

    $onChanges(changes: any) {
        if (changes.refreshKey && !changes.refreshKey.isFirstChange() && !this.hasExternalData) this.load();
    }

    private async fetchData() {
        if (this.mode === 'quick') return this.TarifsService.getGrilleHasErrors(this.id);
        return this.TarifsService.getGrilleErrors(this.id);
    }

    async load() {
        this.loading = true;
        try {
            const data = await this.fetchData();
            this.hasErrorGrille = !!data.hasMissingPrix;
            this.hasErrorGrilleGranulats = !!data.hasMissingGranulats;
            this.hasErrorGrilleEnrobes = !!data.hasMissingEnrobes;
            this.hasErrorGrilleLiants = !!data.hasMissingLiants;
            this.hasErrorGrillePrestations = !!data.hasMissingPrestations;
            this.hasErrorGrilleTransports = !!data.hasMissingTransports;
            if (!this.hasErrorGrille && this.mode !== 'quick') {
                this.showSuccess = true;
                this.$timeout(() => {
                    this.showSuccess = false;
                }, 1000);
            }
        } catch (e) {
            console.error('GrilleErrors:', e);
        } finally {
            this.loading = false;
        }
    }

    get hasExternalData() {
        return this.hasError != null;
    }

    get currentError(): boolean {
        if (this.hasExternalData) return !!this.hasError;
        if (!this.section) return this.hasErrorGrille;
        const map: Record<string, boolean> = {
            granulats: this.hasErrorGrilleGranulats,
            enrobes: this.hasErrorGrilleEnrobes,
            liants: this.hasErrorGrilleLiants,
            prestations: this.hasErrorGrillePrestations,
            transports: this.hasErrorGrilleTransports
        };
        return map[this.section] ?? this.hasErrorGrille;
    }
}
